(function($, w, d){
     /* start popins features */
    $(d).on("click", ".js-popup-button", function (event) {
        event.preventDefault();
        $("html").addClass("disable-scroll");
        var popup_url = d.querySelector('[data-js-popup-name="' + this.getAttribute('data-url') + '"]');
        var popup_bg = d.querySelector('[data-js-popup-bg]');
        var popup = d.querySelector('.js-popup');
        var popup_box = d.querySelector('[data-js-popup-name="' + this.getAttribute('data-url') + '"]' + ' .popup-box');
        var storage = '[data-js-popup-storage="' + this.getAttribute('data-url') + '"]';
        var footer = d.querySelector('#shopify-section-footer');
        popup_bg.classList.remove('popup__bg_img');
        popup_bg.classList.add("popup__bg_white");
        popup_bg.classList.add("animate");
        popup.classList.add("show");
        footer.style.setProperty('display', 'none');
        if (popup_url) {
            popup_url.classList.add("show");
            popup_url.classList.add("visible");
        } else {
            alert('Please check if the URL was assigned to the Theme Global Settings (Popup Feature URL enabled). Please contact your developer if you are not sure what you need to do.');
            location.reload();
            return false;
        }
        d.body.classList.add("popup-overflow-hidden");
        $(storage).load(this.href, function () {
            $(this).trigger("create");
            popup_box.classList.add("active");
        });
  });
  /* end popins features */
  /* start close popup here */
  $(d).on("click", ".popup-account__close", function () {
    $("html").removeClass("disable-scroll");
    var popup_url = d.querySelector('[data-js-popup-name="' + this.getAttribute('data-js-popup-name') + '"]');
    var popup_bg = d.querySelector('[data-js-popup-bg');
    var popup = d.querySelector('.js-popup');
    var popup_box = d.querySelector('[data-popup-content');
    var storage = '[data-js-popup-storage="' + this.getAttribute('data-js-popup-name') + '"]';
    var footer = d.querySelector('#MainContent');
    var footer_display = d.querySelector('#shopify-section-footer');
    $(storage).empty();
    popup_box.classList.remove("active");
    popup_bg.classList.add('popup__bg_img');
    popup_bg.classList.remove("popup__bg_white");
    popup_bg.classList.remove("animate");
    popup.classList.remove("show");
    popup_url.classList.remove("show");
    popup_url.classList.remove("visible");
    d.body.classList.remove("popup-overflow-hidden");
    footer.style.removeProperty('margin-bottom');
    footer_display.style.setProperty('display', 'inherit');
    return true;
  });

})($, window, document);